import { useQuery, useMutation } from "@tanstack/react-query";
import http_payroll from "AppQuries/utils/http_payroll";
import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";

const getAllShiftTypes = async ({ companyCode, isTrue=true }) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.GetAllShiftType}?isAll=true&CompanyCode=${companyCode}`
  );
  return data;
};

const getShiftTypeById = async ({ code }) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.GetShiftType}?ShiftTypeID=${code}`
  );
  return data;
};

const insertShiftType = async (input) => {
  const { data } = await http_payroll.post(Api_EndPoints.InsertShiftType, input);
  return data;
};

const updateShiftType = async (input) => {
  const { data } = await http_payroll.put(Api_EndPoints.UpdateShiftType, input);
  return data;
};

const deleteShiftType = async ({ companyCode, code }) => {
  const { data } = await http_payroll.delete(
    `${Api_EndPoints.DeleteShiftType}?CompanyCode=${companyCode}&ShiftTypeID=${code}`
  );
  return data;
};

export const useGetShiftTypesQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.GetAllShiftType],
    queryFn: () => getAllShiftTypes(input),
  });
};

export const useGetShiftTypeByIdQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.GetShiftType],
    queryFn: () => getShiftTypeById(input),
    refetchOnWindowFocus: false,
  });
};

export const useInsertShiftTypeMutation = () => {
  return useMutation({
    mutationFn: insertShiftType,
  });
};

export const useUpdateShiftTypeMutation = () => {
  return useMutation({
    mutationFn: updateShiftType,
  });
};

export const useDeleteShiftTypeMutation = () => {
  return useMutation({
    mutationFn: deleteShiftType,
  });
};
